/* eslint-disable no-useless-catch */

/**
 * AudioAnalysis service
 */

// Utils
import { HTTP_METHOD } from 'utils/constants';
import { IParamGetList } from 'models/UserRequest';

// Configs
import AdminService from 'configs/api/adminService';

const ENDPOINTS = {
  API_GET_AUDIO_ANALYSIS: ['/voice-analysis', HTTP_METHOD.GET],
  API_EXPORT_AUDIO_ANALYSIS: ['/voice-analysis/export', HTTP_METHOD.GET],
};

class AudioAnalysisService extends AdminService {
  constructor() {
    super();
  }

  async getAudioAnalysis(params: IParamGetList) {
    try {
      const results = await this.request(ENDPOINTS.API_GET_AUDIO_ANALYSIS, [], null, params);
      return results?.data?.results;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }

  async exportAudioAnalysis(data?: IParamGetList): Promise<any> {
    try {
      const results = await this.request(
        ENDPOINTS.API_EXPORT_AUDIO_ANALYSIS,
        [],
        { responseType: 'blob' },
        data
      );
      return results;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }
}

export default new AudioAnalysisService();
